export const a11y = {
    ariaLive: 'Loading',
    ariaLabel: "We're loading this section",
};
//# sourceMappingURL=strings.js.map